const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'];

/** Human-readable byte size, e.g. 1536 -> "1.5 KB". */
export const formatFileSize = (bytes: number): string => {
    if (!Number.isFinite(bytes) || bytes < 0) return '';
    let value = bytes;
    let unit = 0;
    while (value >= 1024 && unit < UNITS.length - 1) {
        value /= 1024;
        unit++;
    }
    let rounded = unit === 0 ? value : Number(value.toFixed(value < 10 ? 1 : 0));
    // Rounding can reach the next unit (1048575 B -> "1024 KB"); show it as "1 MB" instead.
    if (rounded >= 1024 && unit < UNITS.length - 1) {
        rounded = 1;
        unit++;
    }
    return `${rounded} ${UNITS[unit]}`;
};

/** Localised calendar date for an ISO timestamp, or '' when missing/invalid. */
export const formatFileDate = (iso: string | null | undefined, locale?: string): string => {
    if (!iso) return '';
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString(locale, { year: 'numeric', month: 'short', day: 'numeric' });
};
